import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

export interface SettingsCardProps {
  icon: LucideIcon;
  title: ReactNode;
  description?: ReactNode;
  headingAction?: ReactNode;
  headingDetails?: ReactNode;
  className?: string;
  headingClassName?: string;
  children?: ReactNode;
}

export const SettingsCard = ({
  icon: Icon,
  title,
  description,
  headingAction,
  headingDetails,
  className = '',
  headingClassName = '',
  children,
}: SettingsCardProps) => (
  <article className={`simple-card ${className}`.trim()}>
    <div className={`card-heading ${headingAction ? 'has-action' : ''} ${headingClassName}`.trim()}>
      <Icon />
      <div>
        <h2>{title}</h2>
        {description ? <p>{description}</p> : null}
        {headingDetails}
      </div>
      {headingAction}
    </div>
    {children}
  </article>
);
